import React, { useContext } from 'react'
import { IntegrationsCol } from './integrations-col'
import { DomainIntegrationsManagerContext } from '../context'
import { GetDomainIntegrationResponse, GetSlackDomainIntegrationResponse } from '@pushly/models/lib/structs/domains'
import SlackIntegration from '../providers/slack-integration'
import { DomainIntegrationProviders } from '@pushly/models/lib/enums/domain-integration-providers'

const SLACK_FEAT_FLAG = 'FEAT_DOMAIN_INTEGRATIONS_SLACK'

const isSlackProvider = (di: GetDomainIntegrationResponse) => di.provider === DomainIntegrationProviders.SLACK

const toSlackGetResponse = (di: GetDomainIntegrationResponse) =>
    GetSlackDomainIntegrationResponse.fromGetDomainIntegrationResponse(di)

export const CommunicationPlatformIntegrations: React.FC = () => {
    const { loading, domain, integrations } = useContext(DomainIntegrationsManagerContext)

    const isSlackFeatEnabled = domain?.flags?.includes(SLACK_FEAT_FLAG) ?? false

    const slackIntegrations: GetSlackDomainIntegrationResponse[] =
        integrations?.filter(isSlackProvider).map(toSlackGetResponse) ?? []

    return !isSlackFeatEnabled ? null : (
        <IntegrationsCol
            className="communication-platform-integrations"
            label="Communication & Messengers"
            loading={loading}
        >
            <SlackIntegration loading={loading} mode="add" className="new-slack-integration" />
            {slackIntegrations.map((di) => (
                <SlackIntegration key={di.id} loading={loading} mode="edit" integration={di} />
            ))}
        </IntegrationsCol>
    )
}
